import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { billerBeneficiariesReducer, BILLERS_BENEFICIARIES_FEATURE_KEY, BILLERS_FEATURE_KEY, billersReducer, loadPendingBillsReducer, PENDING_BILLS_FEATURE_KEY } from './data-access/store/reducers';
import { BillersEffects } from './data-access/store/effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(BILLERS_FEATURE_KEY, billersReducer),
    StoreModule.forFeature(BILLERS_BENEFICIARIES_FEATURE_KEY, billerBeneficiariesReducer),
    StoreModule.forFeature(PENDING_BILLS_FEATURE_KEY, loadPendingBillsReducer),
    EffectsModule.forFeature([BillersEffects]),
  ],
})
export class SbkFeatureBillPaymentsModule { }
